export default __webpack_public_path__ + "static/German_Flag-834e65ef2fb2186dab66b91b943178a9.svg";